/* eslint-disable import/prefer-default-export */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { getDonationButtonCurrenciesURL, getDonationButtonURL } from '../../endpoints';
import axiosInstance from '../../helpers/axiosInstance';
import Donation from '../../interfaces/Donation';
import DonationCurrency from '../../interfaces/DonationCurrency';

export const fetchButton = createAsyncThunk(
	'DONATION/FETCH_BUTTON',
	(id: string, { rejectWithValue }) => {
		return axiosInstance
			.get<Donation>(getDonationButtonURL(id))
			.then(({ data }) => data)
			.catch((e) => rejectWithValue(e.response?.data));
	}
);

export const fetchCurrencies = createAsyncThunk(
	'DONATION/FETCH_CURRENCIES',
	(id: string, { rejectWithValue }) => {
		return axiosInstance
			.get<DonationCurrency[]>(getDonationButtonCurrenciesURL(id))
			.then(({ data }) => data)
			.catch((e) => rejectWithValue(e.response?.data));
	}
);
